import { useState } from "react";
import { TextField } from "@mui/material";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useMediaQuery } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { ja } from "date-fns/locale"; // 日本語ロケールをインポート
import "./FromToDatePickersForNotice.css";

const useStyles = makeStyles((theme) => ({
  datePicker: {
    width: (props) => (props.isMobile ? "100px" : "140px"),
    "& .MuiInputBase-input": {
      paddingTop: 0,
      paddingBottom: 0,
      height: "38px",
      fontSize: "14px",
    },
    "& .MuiInputLabel-root": {
      fontSize: "14px",
      color: "#4dd0e1",
    },
  },
}));

const FromToDatePickersForNotice = (props) => {
  const { setFromDate, setToDate, fromDate, toDate, disabled } = props;
  const isMobile = useMediaQuery("(max-width:960px)");
  const classes = useStyles({ isMobile });

  const [error, setError] = useState("");

  const handleFromDateChange = (newDate) => {
    if (newDate > toDate) {
      setFromDate(newDate);

      // newDateから7日後の日付を設定
      const updatedToDate = new Date(newDate);
      updatedToDate.setDate(updatedToDate.getDate() + 7); // 7日後

      setToDate(updatedToDate);
      setError("");
    } else {
      setError("");
      setFromDate(newDate);
    }
  };

  const handleToDateChange = (newDate) => {
    if (fromDate > newDate) {
      setToDate(newDate);

      // newDateから7日前の日付を設定
      const updatedFromDate = new Date(newDate);
      updatedFromDate.setDate(updatedFromDate.getDate() - 7); // 7日前

      setFromDate(updatedFromDate);
      setError("");
    } else {
      setError("");
      setToDate(newDate);
    }
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} locale={ja}>
      {/* 日本語ロケールを適用 */}
      <div className="DatePickerContentsFlex">
        <div className="DatePickerFlex">
          <DatePicker
            disabled={disabled}
            label={`開始`}
            value={fromDate}
            onChange={handleFromDateChange}
            inputFormat="yyyy/MM/dd" // フォーマットを指定
            renderInput={(params) => (
              <TextField
                {...params}
                className={classes.datePicker}
                style={{ width: isMobile ? "100px" : "140px" }}
              />
            )}
            slotProps={{ calendarHeader: { format: "YYYY年MM月" } }}
          />
        </div>
        <div className="DatePickerFlex">
          <DatePicker
            disabled={disabled}
            label={`終了`}
            value={toDate}
            onChange={handleToDateChange}
            inputFormat="yyyy/MM/dd" // フォーマットを指定
            renderInput={(params) => (
              <TextField
                {...params}
                className={classes.datePicker}
                style={{ width: isMobile ? "100px" : "140px" }}
              />
            )}
            slotProps={{ calendarHeader: { format: "YYYY年MM月" } }}
          />
        </div>
        {error && <div className="ErrorMessage">{error}</div>}
      </div>
    </LocalizationProvider>
  );
};

export default FromToDatePickersForNotice;
